import { animate, state, style, transition, trigger } from '@angular/animations';

export const LeaveToRight = trigger('leaveToRight', [
  state(
    'out',
    style({
      transform: 'translateX(100%)',
      opacity: 0
    })
  ),
  transition('* => out', [
    style({
      transform: 'translateX(0)',
      opacity: 1
    }),
    animate('0.35s ease-out')
  ])
]);
